import * as React from 'react';

interface PresentationModeContextValue {
  isPresentationMode: boolean;
  togglePresentationMode: () => void;
}

// Create the context with default placeholder values
const PresentationModeContext = React.createContext<PresentationModeContextValue>({
  isPresentationMode: false,
  togglePresentationMode: () => {},
});

interface PresentationModeProviderProps {
  children: React.ReactNode;
}

export function PresentationModeProvider({ children }: PresentationModeProviderProps) {
  const [isPresentationMode, setIsPresentationMode] = React.useState(false);

  const togglePresentationMode = () => setIsPresentationMode(prev => !prev);

  return (
    <PresentationModeContext.Provider value={{ isPresentationMode, togglePresentationMode }}>
      {children}
    </PresentationModeContext.Provider>
  );
}

export function usePresentationMode() {
  return React.useContext(PresentationModeContext);
}
